import * as React from 'react'
import { useState, useCallback } from 'react'
import { Button, Callout, Classes, Dialog, Intent } from '@blueprintjs/core'
import { AxiosError } from 'axios'
import { PriceInput } from '../../products_v5/components/JoinedForm/GoodwillfindsCard/Inputs'
import { S } from '../../../utils'
import { showToast } from '../../../Toast'
import APIErrorCallout from '../../../components/errors/APIErrorCallout'

import './RelistDialogStyle.scss'

interface Props {
  isOpen: boolean
  onClose: (changePerformed?: boolean, failedIds?: string[]) => void
  onSubmit: (formData: { price: number | null }) => Promise<{ failed?: string[] }>
  onSubmitted?: () => void
  data: any[]
  recycledProductId?: string | number | null
  hasSold?: boolean
}

const RelistDialog: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  onSubmitted,
  data,
  recycledProductId,
  hasSold
}) => {
  const [price, setPrice] = useState<number | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<AxiosError | null>(null)

  const handleClose = useCallback(() => {
    onClose(false, [])
  }, [onClose])

  const handleSubmit = async () => {
    setLoading(true)
    setError(null)

    try {
      const response = await onSubmit({ price })
      onSubmitted?.()
      showToast(`Relisting ${data.length} item${S(data)}...`, Intent.PRIMARY)
      onClose(true, response.failed)
    } catch (e) {
      setError(e)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog title="Relist" isOpen={isOpen} onClose={handleClose}>
      <div className={Classes.DIALOG_BODY}>
        {error && <APIErrorCallout response={error} />}
        {recycledProductId && (
          <Callout intent={Intent.DANGER}>
            This listing&apos;s product is <strong>recycled</strong>. You must restore it first.
          </Callout>
        )}
        {hasSold && (
          <Callout intent={Intent.WARNING}>
            You have selected a <strong>Sold</strong> listing. Please check to make sure this was intentional.
          </Callout>
        )}
        <p className="extra-bottom-margin">Leave fields blank to use current values</p>
        <PriceInput value={price} onChange={e => setPrice(e.value)} placeholder="Use current" />
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button minimal disabled={loading} onClick={handleClose}>
            Cancel
          </Button>
          <Button intent="primary" loading={loading} onClick={handleSubmit} disabled={!!recycledProductId}>
            Relist {data.length} item{S(data)}
          </Button>
        </div>
      </div>
    </Dialog>
  )
}

export default RelistDialog
